import { Multimedia } from '../models/multimedia';
import { MultimediaResponse } from '../api/responses/multimedia.response';

export const multimediaFromResponse = (
  response: MultimediaResponse,
): Multimedia => {
  return new Multimedia({
    id: response.id,
    alt: response.alt(),
    url: response.url,
    title: response.title,
    extension: response.extension,
    type: response.type,
  });
};
